import type { TabKey } from '@/features/veluvit/components/shell/tab-icon'
import type { Route } from 'next'

/**
 * 메뉴 한 곳 — PC 왼쪽 패널(side-nav) · 모바일 하단 탭(bottom-tabs) · 모바일 메뉴 서랍(nav-drawer)이 같은 항목을 쓴다.
 * 새 메뉴 · 이름 · 주소는 여기에만 더한다(sai-project/layout-policy.md 규칙 4).
 * short — 하단 탭처럼 칸이 좁은 곳에서 쓰는 짧은 이름
 */
type NavItem = { k: TabKey; href: Route; label: string; short?: string }

export const NAV = {
  char: { k: 'char', href: '/', label: '홈' },
  ranking: { k: 'ranking', href: '/ranking', label: '랭킹' },
  explore: { k: 'explore', href: '/explore', label: '탐색' },
  chats: { k: 'chats', href: '/chats', label: '내 대화', short: '대화' },
  // 미션 — 예전엔 내 대화 안의 탭(/chats/mission)이었다. 2026-10-07 따로 메뉴로 빼 스튜디오 왼쪽에 둔다
  mission: { k: 'mission', href: '/mission' as Route, label: '미션' },
  studio: { k: 'studio', href: '/studio-renew' as Route, label: '스튜디오' },
} satisfies Record<string, NavItem>

/** PC 메뉴 — 홈 다음에 둘러볼 곳 · 내 것 · 만들기 순. 랭킹은 임시 숨김.
 *  [2차 개발] 미션(NAV.mission)은 2026-10-08 2차 범위로 넘겨 메뉴에서 뺐다 — 되살릴 땐 NAV.chats 와 NAV.studio 사이에 다시 넣는다 */
export const MAIN_NAV: NavItem[] = [
  NAV.char,
  /* NAV.ranking, */ NAV.explore,
  NAV.chats,
  /* NAV.mission, */ NAV.studio,
]

/** 모바일 하단 탭 — 맨 왼쪽 ☰(서랍)은 bottom-tabs 가 그리고, 나머지는 자주 가는 메뉴. 스튜디오 · 미션은 서랍에서 */
export const BOTTOM_NAV: NavItem[] = [
  NAV.char,
  /* NAV.ranking, */ NAV.explore,
  NAV.chats,
]

/** 지금 경로가 어느 메뉴 소속인지 — 없으면 null(모바일 하단 탭을 숨긴다, 레퍼런스 gnbOn) */
export function activeTab(pathname: string): TabKey | null {
  if (pathname === '/') return 'char'
  if (pathname === '/story') return 'story'
  if (pathname.startsWith('/ranking')) return 'ranking'
  if (pathname.startsWith('/explore')) return 'explore'
  if (pathname.startsWith('/mission')) return 'mission'
  if (pathname.startsWith('/chats')) return 'chats'
  if (
    pathname === '/my' ||
    pathname === '/attendance' ||
    pathname.startsWith('/payment/')
  )
    return 'my'
  if (pathname.startsWith('/studio-renew')) return 'studio'
  return null
}
